import * as yup from "yup";
import { pathSchema } from "features/Path/schema";
import { trigger } from "features/Trigger/TemplateTrigger/Form/schema";
import { CHECK_TARGET_LABELS, DELIVERY_METHOD_LABELS } from "features/Resources/Shared/constants";

const checkTargetValues = Object.keys(CHECK_TARGET_LABELS);
const checkTargetMessage = `Check Target must be one of: ${Object.values(CHECK_TARGET_LABELS).join(", ")}`;

const deliveryMethodValues = Object.keys(DELIVERY_METHOD_LABELS);
const deliveryMethodMessage = `Delivery Method must be one of: ${Object.values(DELIVERY_METHOD_LABELS).join(", ")}`;

export const checkpointTemplateSchema = yup.object({
  pathIds: yup.array().of(yup.string().required()).optional().default([]),
  paths: yup.array().of(pathSchema).optional().default([]),
  name: yup.string().required().label("Title").max(70, "Title cannot be more than 70 characters"),
  checkTarget: yup
    .string()
    .oneOf(checkTargetValues, checkTargetMessage)
    .required()
    .default("new_hire_tasks")
    .label("Check Target"),
  deliveryMethod: yup
    .string()
    .oneOf(deliveryMethodValues, deliveryMethodMessage)
    .required()
    .default("message")
    .label("Delivery Method"),
  recipients: yup
    .array()
    .of(yup.mixed())
    .min(1, "At least one recipient is required")
    .required()
    .default([])
    .label("Recipients"),
  evaluateAtTrigger: trigger.required().label("Evaluate At"),
  allowWeekends: yup.boolean().optional().default(false).label("Allow Weekends"),
});

export type CheckpointTemplateSchema = yup.InferType<typeof checkpointTemplateSchema>;
